/**
 * A map that can be searched in both directions
 */
export default class TwoWayMap<k, v> {
  map: Map<k, v>;

  reverseMap: Map<v, k>;

  constructor(map: Map<k, v>) {
    this.map = map;
    this.reverseMap = new Map<v, k>(
      [...map.entries()].map((entry) => [entry[1], entry[0]])
    );
  }

  get(key: k) {
    return this.map.get(key);
  }

  revGet(key: v): k | undefined {
    return this.reverseMap.get(key);
  }

  values() {
    return this.map.values();
  }

  keys() {
    return this.map.keys();
  }
}
